import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Nakit açığı alarmı. Yük KİŞİSEL VERİ TAŞIMAZ; istemci ayrıntıyı yetki denetimli `/cashflow/projection`
 * ucundan çeker. Şirket + gün başına BİR kez üretilir (`cashflow_alerts` tekil dizini).
 */
export const cashflowShortfallProjectedV1 = defineEvent({
    type: "cashflow.shortfall.projected",
    version: 1,
    description: "Projeksiyonda nakit açığı günü öngörüldü (şirket + gün başına bir kez)",
    realtime: ["tenant"],
    payload: z.object({
        companyId: z.uuid(),
        scenario: z.enum(["OPTIMISTIC", "BASE", "PESSIMISTIC"]),
        /** Açığın görüldüğü İLK gün. */
        firstShortfallDate: z.iso.date(),
        /** Kuruş (dizge): ufuk içindeki EN DÜŞÜK kullanılabilir nakit (bakiye + KMH). */
        lowestAvailable: z.string(),
        lowestDate: z.iso.date(),
        shortfallDayCount: z.number().int(),
        horizonDays: z.number().int(),
    }),
});
//# sourceMappingURL=cashflow.v1.js.map